import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';

class Confirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpened: props.visible,
    };
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
  }

  onButtonClick() {
    // Since the modal is inside the button click events will propagate up.
    if (!this.state.isOpened) {
      this.setState({
        isOpened: true,
      });
    }
  }

  onClose(event) {
    if (event) {
      event.stopPropagation();
    }
    this.setState({
      isOpened: false,
    });

    if (typeof this.props.onClose === 'function') {
      this.props.onClose();
    }
  }

  onConfirm(event) {
    event.stopPropagation();
    this.setState({
      isOpened: false,
    });
    this.props.onConfirm();
  }

  render() {
    var cancelButton = this.props.showCancelButton ? (
      <Button variant="white" onClick={this.onClose}>
        {this.props.cancelText}
      </Button>
    ) : null;
    var modal = (
      <Modal
        show={this.state.isOpened}
        onHide={this.onClose}
        className={'confirm_modal' + (this.props.className || ' ')}
        dialogClassName={this.props.dialogClassName}
        keyboard={this.props.keyboard}
        backdrop={this.props.backdrop}
        enforceFocus={this.props.enforceFocus}
      >
        <Modal.Header>
          <Modal.Title>
            <div>
              <div className="icon">
                <img src={this.props.icon} alt="" />
              </div>
              <h2>{this.props.title}</h2>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.props.body}</Modal.Body>
        <Modal.Footer>
          {cancelButton}
          <Button variant="red" className={this.props.confirmClass} onClick={this.onConfirm}>
            {this.props.confirmText}
          </Button>
        </Modal.Footer>
      </Modal>
    );

    let content;
    if (this.props.children && !this.props.noBtn) {
      var btn = React.Children.only(this.props.children);
      content = React.cloneElement(
        btn,
        {
          onClick: this.onButtonClick,
          style: this.props.style,
        },
        btn.props.children,
        modal
      );
    } else if (!this.props.noBtn) {
      content = (
        <Button onClick={this.onButtonClick} style={this.props.style}>
          {this.props.buttonText}
          {modal}
        </Button>
      );
    } else {
      content = modal;
    }

    return content;
  }
}

Confirm.propTypes = {
  body: PropTypes.node.isRequired,
  icon: PropTypes.string,
  buttonText: PropTypes.node,
  cancelText: PropTypes.node,
  className: PropTypes.string,
  confirmBtn: PropTypes.string,
  confirmText: PropTypes.node,
  dialogClassName: PropTypes.string,
  keyboard: PropTypes.bool,
  backdrop: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  enforceFocus: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  showCancelButton: PropTypes.bool.isRequired,
  title: PropTypes.node.isRequired,
  visible: PropTypes.bool,
  noBtn: PropTypes.bool,
};

Confirm.defaultProps = {
  cancelText: 'Cancel',
  confirmText: 'Confirm',
  showCancelButton: true,
};

export { Confirm };
export default Confirm;
